


























































































































































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    stepBar: require("../../shared/step_bar.vue")
    organizationStep: require("../../shared/lead_organization.vue")

  data: ->
    current_step: 1
    file: null
    apiErrorMessages: []
    raw_contacts: []
    line_errors: {}
    has_valid: null
    has_duplicates: null
    file_errors: null
    encoding: null
    has_header: null
    encoding_options: [
      {value: 'UTF-8', text: 'UTF-8'}
      {value: 'ISO-8859-1', text: 'ISO-8859-1'}
      {value: 'CP850', text: 'CP850'}
      {value: 'macCroatian', text: 'MAC'}
    ]
    import_valid_only: false
    message: null
    menu_open: true
    custom_fields: []
    presigned_url: null
    filename: null
    websocket_id: null
    upload_progress: 0
    validation_state: 'none'
    creation_progress: 0
    file_total_count: 0
    creation_in_progress: false
    valid: false
    selected_group_id: null
    selected_flow_id: null
    selected_user_id: Session.current_user.id
    selected_tags_ids: null
    import_finished: false
    work_on_duplicates: false
    multiple_groups: false
    groups: null
    remaining: null


  watch:
    file: (val) ->
      @current_step = 2 unless val == null
      
  methods:
    newImport: ->
      @current_step = 1
      @import_finished = false
      @selected_group_id = null
      @selected_flow_id = null
      @selected_user_id = Session.current_user.id
      @selected_tags_ids = null
      @upload_progress = 0
      @validation_state = 'none'
      @creation_progress = 0
      @file_total_count = 0

      @file = null

    selectUser: (user_id) ->
      @selected_user_id = parseInt(user_id)
    
    selectTags: (tags) ->
      @selected_tags_ids = tags unless tags.lentgh == 0

    nextStep: ->
      @current_step++ if @current_step < 5

    switchGroup: (send_to_group) ->
      @selected_group_id = null unless send_to_group

    switchFlow: (send_to_flow) ->
      @selected_flow_id = null unless send_to_flow

    switchRemaining: (new_remaining) ->
      @remaining = new_remaining
    
    selectGroup: (groupId) ->
      @selected_group_id = groupId

    selectFlow: (flowId) ->
      @selected_flow_id = flowId
        
    fileInput: (event) ->
      @resetValidation()
      files = event.target.files || event.dataTransfer.files
      if files.length
        @file = files[0]
        IntegrationsResource.s3PresignedUrl(@s3PresignedUrlSuccess, @s3PresignedUrlFailure, params: { filename: @file.name })

    s3PresignedUrlSuccess: (data) ->
      @presigned_url = data.body.url
      @filename = data.body.filename
      @uploadFileToS3()

    s3PresignedUrlFailure: ->
      alertify.error(this.$t('contacts_csv.feedback.s3PresignedUrlFailure'))

    uploadFileToS3: ->
      return if !@presigned_url || !@filename
      jQuery.ajax(
        type: 'PUT',
        url: @presigned_url,
        contentType: @file.type,
        processData: false,
        data: @file,
        xhr: =>
          xhr = jQuery.ajaxSettings.xhr()
          if(xhr.upload)
            xhr.upload.addEventListener('progress', @uploadProgress, false)
          xhr
        success: @uploadFileToS3Success,
        error: @uploadFileToS3Failure
      )

    uploadProgress: (data) ->
      total = data.total
      loaded = data.loaded
      @upload_progress = loaded * 100.0 / total

    uploadFileToS3Success: (data, a, b) ->
      jQuery('input#file[type="file"]').val(null);
      @file_url = @presigned_url.split('?')[0]
      @validateFile()

    uploadFileToS3Failure: ->
      alertify.error(this.$t('contacts_csv.feedback.uploadFileToS3Failure'))

    validateFile: ->
      @resetValidation(false)
      @groups = null
      @subscribeToWebsocketChannel(@validationWebsocketCallback)
      @resource.importCsv(null, @failImportValidation, @params(false))

    failImportValidation: ->
      @subscription.unsubscribe()

    subscribeToWebsocketChannel: (received_callback) ->
      @websocket_id = @generateToken()
      @subscription = ActionCable.connect().subscriptions.create(
        { channel: 'ContactsImportChannel', @websocket_id },
        received: received_callback
      )

    exportDefaultCSV: ->
      jQuery.ajax({
        url: @example_file_path,
        success: @defaultLoaded
      })

    defaultLoaded: (data) ->
      rows = data.split('\n')
      for row of rows
        if row < rows.length - 1
          for custom in @custom_fields
            rows[row] += ";" + custom.field

      csvContent = rows.join("\n");
      link = document.createElement("a");
      link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent('\uFEFF'+csvContent));
      link.setAttribute("download", "reev-contatos-exemplo.csv");
      document.body.appendChild(link);
      link.click();

    validationWebsocketCallback: (data) ->
      if data.error
        @subscription.unsubscribe()
        @newImport()
        return alertify.error(data.error)

      if data.info
        if data.has_valid
          @has_valid = data.has_valid
        if data.has_duplicates
          @has_duplicates = data.has_duplicates

        @encoding = data.info.encoding
        @has_header = data.info.has_header
        @file_total_count = data.info.total_count
      @loadSetErrors(data.line_errors)
      @concatRawContacts(data.raw_contacts)
      @setGroups(data.groups)
      @remaining = data.remaining
      @file_errors = data.file_errors
      if data.finished
        @validation_state = if @has_errors then 'error' else 'ok'
        @subscription.unsubscribe()
        @valid = data.valid

    concatRawContacts: (raw_contacts) ->
      @raw_contact_index = @raw_contacts.length
      for raw_contact in raw_contacts
        raw_contact.index = @raw_contact_index
        @raw_contact_index += 1
      @raw_contacts = @raw_contacts.concat(raw_contacts)

    setGroups: (groups) ->
      if groups != null 
        if Array.isArray(groups) && groups.length > 0 
          @groups = groups
          @multiple_groups = true

    importSuccess: ->
      @import_finished = true

    importFile: (only_valids=false) ->
      console.log @valid
      console.log only_valids
      console.log @work_on_duplicates
      console.log @params(!only_valids, only_valids)

      return unless @valid or only_valids or @work_on_duplicates
      @creation_in_progress = true
      @subscribeToWebsocketChannel(@importWebsocketCallback)
      @resource.importCsv(@importSuccess, @importFileFailure, @params(!only_valids, only_valids))

    importWebsocketCallback: (data) ->
      if data.warning
        alertify.error(data.warning)
      if data.error
        @subscription.unsubscribe()
        @file = null
        alertify.error(data.error)
      if data.finished
        @nextStep()
        @creation_progress = 100.0
        @subscription.unsubscribe()
        alertify.success this.$t('contacts_csv.feedback.importSuccess')
        @notifyIntercom()
      else
        @creation_progress = data.count / parseFloat(@file_total_count) * 100.0

    importFileFailure: ->
      @subscription.unsubscribe()
      alertify.error('Falha ao importar arquivo')

    menu_open_change: ->
      @menu_open = !@menu_open

    workOnDuplicates: ->
      current_user_role = Session.current_user.role
      message = ''

      if current_user_role == "admin" || 
         current_user_role == "manager" || 
         ((current_user_role == "seller" || current_user_role == "sdr") && @company.account_setting.seller_can_change_responsability)
        message = this.$t('contacts_csv.feedback.responsabilityChangeCheck')
      else
        message = this.$t('contacts_csv.feedback.contactOwnerSelectCheck')
      @message = message
      EventsBus.$emit('confirm-modal-show', id: 'confirm-select-duplicate-confirmation-modal')

    update: (confirm) ->
      if !confirm
        @work_on_duplicates = false
      else
        @work_on_duplicates = true
        @nextStep()

    updateActiveInFlow: (confirm) ->
      if confirm
        @nextStep()
        @importFile(@import_valid_only)

    confirmImport: ->
      if (@work_on_duplicates)
        @showConfirmFlowModal()
      else
        @nextStep()
        @importFile(@import_valid_only)

    confirmImportValidOnly: ->
      @nextStep()
      @import_valid_only = true

    showConfirmFlowModal: ->
      EventsBus.$emit('confirm-modal-show', id: 'confirm-flow-select-confirmation-modal')

    notifyIntercom: ->
      IntercomCtrl.trackEvent(this.$t('contacts_csv.label.finishImportTitle'), this.$t('contacts_csv.label.finishImportMessage', { num: @raw_contacts.length }) )

    importWithEncoding: (encoding) ->
      @encoding = encoding
      @validateFile()

    humanAttribute: (attribute) ->
      human_attribute = this.$t('contacts.attributes.' + attribute) if(this.$te('contacts.attributes.' + attribute))
      attribute_name = human_attribute || attribute
      attribute_name.charAt(0).toUpperCase() + attribute_name.slice(1)

    cellHasError: (row_index, col_index) ->
      row_index += (if @has_header then 2 else 1)
      !!@cells_with_errors.findByProps(row: row_index.toString(), col: col_index.toString())

    loadSetErrors: (line_errors) ->
      return if !line_errors || jQuery.isEmptyObject(line_errors)
      for row, attributes_errors of line_errors
        for attribute, errors of attributes_errors
          error = errors[0]
          attribute = 'business' if attribute == 'business.name'
          col = @isCustomFieldError(attribute, error)
          if col
            error = error.error
          else
            @attributes_reference.forEach (attribute_reference, index) =>
              if attribute_reference[0] == attribute
                col = index
          list = @line_errors[error] || []
          list.push({row, attribute, col: col?.toString()})
          Vue.set(@line_errors, error, list)

    isCustomFieldError: (error_field, error) ->
      return unless /contact_custom_fields\[\d{1,4}\]\.value/.exec(error_field)
      for custom_field, index in @custom_fields
        return index + @fixed_columns_size if custom_field.id == parseInt(error.custom_field_id)
      null

    humanCells: (cells) ->
      human_cells = []
      cells.forEach (cell) =>
        col = @all_attributes_letters[parseInt(cell.col)]
        human_cells.push(cell.row + col)
      human_cells.join(', ')

    loadCustomFields: ->
      Loader.on()
      new CustomFieldsResource().index(@loadCustomFieldsSuccess, @unknownError)

    loadCustomFieldsSuccess: (data) ->
      @custom_fields = data.custom_fields
      Loader.off()

    resetValidation: (reset_upload = true) ->
      @upload_progress = 0 if reset_upload
      @raw_contacts = @defaultRawContactsHeader()
      @line_errors = {}
      @valid = false
      @validation_state = 'none'
      @creation_progress = 0
      @file_total_count = 1
      @creation_progress = 0
      @creation_in_progress = false

    params: (save = false, valid_only = false) ->
      { @file_url, force_encoding: @encoding, user_id: @selected_user_id, flow_id: @selected_flow_id, group_id: @selected_group_id, contact_tags: @selected_tags_ids, @websocket_id, save, valid_only, @work_on_duplicates, ignored_groups: @ignored_groups }

    defaultRawContactsHeader: ->
      header = []
      header.index = 0
      sub_header = []
      sub_header.index = 1
      [header, sub_header]

    generateToken: ->
      Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2)

  computed:
    ignored_groups: ->
      ignored = []
      if @groups != null
        for group in @groups
          ignored.push group.group.name if !group.selected
      ignored

    attributes_reference: ->
      attributes_names = ['first_name', 'last_name', 'email', 'business', 'position', 'telephone', 'cellphone', 'address', 'url', 'linkedin', 'Variável 1', 'Variável 2', 'Variável 3', 'Grupo']

      email_index = attributes_names.findIndex 'email'
      if Session.current_company.cpf_active
        attributes_names.splice(email_index + 1, 0, 'cpf')

      linkedin_index = attributes_names.findIndex 'linkedin'
      if Session.current_company.cnpj_active
        attributes_names.splice(linkedin_index + 1, 0, 'cnpj')

      attributes_list = []
      index = 0
      for attribute_name in attributes_names
        attributes_list.push [attribute_name, String.fromCharCode('A'.charCodeAt(0) + index)]
        index++

      attributes_list

    all_attributes_letters: ->
      [
       'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
       'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AL','AK','AM','AN','AO'
      ]

    example_file_path: ->
      "/static/reev-contatos-exemplo.csv"

    cells_with_errors: ->
      cells = []
      for error, error_cells of @line_errors
        cells = cells.concat(error_cells)
      cells

    has_line_errors: ->
      @line_errors && Object.keys(@line_errors).length

    has_file_errors: ->
      @file_errors && Object.keys(@file_errors).length

    has_errors: ->
      @has_line_errors || @has_file_errors

    start_line: ->
      if @has_header then 2 else 1

    validation_progress: ->
      if @current_step > 2
        (@raw_contacts.length) / parseFloat(@file_total_count) * 100.0

    validation_finished: ->
      @validation_state != 'none'

    loading: ->
      !@validation_finished || @creation_in_progress

    visible_raw_contacts: ->
      @raw_contacts.slice(0, 1500)

    fixed_columns_size: ->
      @attributes_reference.length

  created: ->
    @company = Session.current_company
    @resource = new ContactsResource(@company.id)
    @loadCustomFields()

exports.default = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/import/csv.vue